export const SET_ANALYSIS_PROFILE = 'SET_ANALYSIS_PROFILE';

export const START_ANALYSIS_REQUEST = 'START_ANALYSIS_REQUEST';
export const START_ANALYSIS_SUCCESS = 'START_ANALYSIS_SUCCESS';
export const START_ANALYSIS_FAILURE = 'START_ANALYSIS_FAILURE';

export const FETCH_ANALYSIS_REQUEST = 'FETCH_ANALYSIS_REQUEST';
export const FETCH_ANALYSIS_SUCCESS = 'FETCH_ANALYSIS_SUCCESS';
export const FETCH_ANALYSIS_FAILURE = 'FETCH_ANALYSIS_FAILURE';

export const PING_ANALYSIS_REQUEST = 'PING_ANALYSIS_REQUEST';
export const PING_ANALYSIS_SUCCESS = 'PING_ANALYSIS_SUCCESS';
export const PING_ANALYSIS_FAILURE = 'PING_ANALYSIS_FAILURE';

export const CANCEL_ANALYSIS_REQUEST = 'CANCEL_ANALYSIS_REQUEST';
export const CANCEL_ANALYSIS_SUCCESS = 'CANCEL_ANALYSIS_SUCCESS';
export const CANCEL_ANALYSIS_FAILURE = 'CANCEL_ANALYSIS_FAILURE';

export const SET_ORDER_BY = 'SET_ORDER_BY';
export const SET_ORDER = 'SET_ORDER';
export const SET_FEATURE_SELECTED = 'SET_FEATURE_SELECTED';
export const SET_ALL_FEATURES_SELECTED = 'SET_ALL_FEATURES_SELECTED';

export const CLEAR_ANALYSIS = 'CLEAR_ANALYSIS';

export const EXPORT_ANALYSIS_REQUEST = 'EXPORT_ANALYSIS_REQUEST';
export const EXPORT_ANALYSIS_SUCCESS = 'EXPORT_ANALYSIS_SUCCESS';
export const EXPORT_ANALYSIS_FAILURE = 'EXPORT_ANALYSIS_FAILURE';

export const FETCH_ANALYSES_REQUEST = 'FETCH_ANALYSES_REQUEST';
export const FETCH_ANALYSES_SUCCESS = 'FETCH_ANALYSES_SUCCESS';
export const FETCH_ANALYSES_FAILURE = 'FETCH_ANALYSES_FAILURE';